import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../Cadenas/Cadenas";
import { catTiposFactura } from "../Categorias y Estados/catTiposFactura";
import { catTiposServicio } from "../Categorias y Estados/catTiposServicio";
import { estActivo } from "../Categorias y Estados/estActivo";
import { CondicionesFacturacion } from "../CondicionesFacturacion/CondicionesFacturacion";
import { CondicionesPago } from "../CondicionesPago/CondicionesPago";
import { Empresas } from "../Empresas/Empresas";
import { GruposEmpresas } from "../GruposEmpresas/GruposEmpresas";
import { ACTImportarDatos } from "./ACTImportarDatos";
import { ACTVerImportaciones } from "./ACTVerImportaciones";
    


const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Cliente ID' }),
        c_clienteguid_id: new EntityColumn<string>({ name: 'c_clienteguid_id', type: 'char', length: 36, flags: c.FK, prompt: 'Clienteguid Id' }),
        c_empresa_id: new EntityColumn<string>({ name: 'c_empresa_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Empresa' }),
        vc_nombre_cliente: new EntityColumn<string>({ name: 'vc_nombre_cliente', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        c_condicionfacturacion_id: new EntityColumn<string>({ name: 'c_condicionfacturacion_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Condición de facturación' }),
        c_condicionpago_id: new EntityColumn<string>({ name: 'c_condicionpago_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Condición de pago' }),
        vc_codigoexterno: new EntityColumn<string>({ name: 'vc_codigoexterno', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Código externo' }),
        c_tipofactura_id: new EntityColumn<string>({ name: 'c_tipofactura_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo de factura' }),
        c_tiposervicio_id: new EntityColumn<string>({ name: 'c_tiposervicio_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo de servicio' }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        vc_url_dashboard: new EntityColumn<string>({ name: 'vc_url_dashboard', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'URL Dashboard' }),
        vc_workspace_id: new EntityColumn<string>({ name: 'vc_workspace_id', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Workspace Id' }),
        vc_report_id: new EntityColumn<string>({ name: 'vc_report_id', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Report Id' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clie_brwStandard: { name: 'clie_brwStandard', keyMappings: { c_cliente_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'CondicionesFacturacion': {
            name: 'CondicionesFacturacion',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new CondicionesFacturacion(client, parentKeys)
        },
        'CondicionesPago': {
            name: 'CondicionesPago',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new CondicionesPago(client, parentKeys)
        },
        'Empresas': {
            name: 'Empresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Empresas(client, parentKeys)
        },
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new GruposEmpresas(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },
        'TiposFactura': {
            name: 'TiposFactura',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposFactura(client, parentKeys)
        },
        'TiposServicio': {
            name: 'TiposServicio',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposServicio(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo(client, parentKeys)
        }
    }
)

const clientActions = () =>
(
    {
        ACTImportarDatos: ACTImportarDatos,
        ACTVerImportaciones: ACTVerImportaciones
    }
)

export class ClientesDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('Clientes');
    }
}